import _ from "lodash";

import {
  derived,
  inline,
} from "CommonState/action-helpers";

const treeKey = name => `ui.tree-${ name }`;

const getTreeNodeExpanded = derived(
  "expanded",
  (state, { treeName, node: { data: { id } } }) => _.get(state, `${ treeKey(treeName) }.${ id }`),
  (state, { node: { depth } }) => depth,
  (nodeState, depth) => nodeState ? nodeState.expanded : depth > 0,
);

const getTreeState = derived("treeState", (state, { treeName }) => _.get(state, treeKey(treeName)));
const getTreeStateFrom = treeName => derived("treeState", state => _.get(state, treeKey(treeName)));

function isExpanded(treeState, node) {
  const nodeState = treeState && treeState[node.data.id];
  return nodeState ? nodeState.expanded : !_.isNumber(node.depth) || node.depth > 0;
}

function isVisible(treeState, node, userCheck) {
  if (node.depth === 0) {
    return true;
  }
  node = node.parentNode;
  while (node && (!userCheck || userCheck(node))) {
    if (!isExpanded(treeState, node)) {
      return false;
    }
    if (node.depth === 0) {
      break;
    }
    node = node.parentNode;
  }
  return true;
}

export const TreeUtils = {
  getTreeNodeExpanded,
  getTreeState,
  getTreeStateFrom,
  isExpanded,
  isVisible,
};

export function setTreeNodeExpanded(name, id, expanded) {
  const key = treeKey(name);
  return inline(key, state => {
    _.set(state, `${ key }.${ id }.expanded`, expanded);
  });
}

export function setWholeTreeExpandedState(name, nodeList, expanded) {
  const key = treeKey(name);
  return inline(key, state => {
    let treeState = _.get(state, key);
    if (!treeState) {
      _.set(state, key, treeState = {});
    }
    _.forOwn(nodeList, ({ data: { id } }) => {
      const nodeState = treeState[id] || (treeState[id] = {});
      nodeState.expanded = expanded;
    });
  });
}
